import { Text } from '@/components/ui/catalyst/text';

import { useRequestPage } from './contexts/RequestPageContext';
import { RequestDetails } from './request-details';

/**
 * Left sidebar showing request configuration details
 * Displays the "up next" step, request method, and configuration options
 */
export const RequestPageSidebar = () => {
  const { request, provider, matterId, providerId, requestId, refetchRequest } =
    useRequestPage();

  // Safety check (should never happen due to parent check)
  if (!request || !provider) return null;

  return (
    <div className="w-[392px] shrink-0 overflow-y-auto border-r border-zinc-200 bg-white">
      <div className="px-5 py-6">
        <Text className="mb-5 text-xs font-semibold uppercase tracking-[0.14em] text-zinc-500">
          Request Configuration
        </Text>
        <RequestDetails
          request={request}
          provider={provider}
          matterId={matterId}
          providerId={providerId}
          requestId={requestId}
          onUpdate={refetchRequest}
        />
      </div>
    </div>
  );
};
